import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { clearPrecogCounter, getCounterPrecog } from "../../../store/actions/precog/counter";
import WidgetsPrecogCard from "./card";
import BarChart from "./barChart";
import { Tooltip } from "antd";

const WidgetAccountedFor = () => {
  const dispatch = useDispatch();
  const counterStatus = useSelector(state => state.precog?.counter?.status);
  const counterData = useSelector(state => state.precog?.counter?.data);
  const [totalToBeAccounted, setTotalToBeAccounted] = useState(0);
  const [totalAccounted, setTotalAccounted] = useState(0);

  useEffect(() => {
    dispatch(getCounterPrecog()).then(res => {      
      setTotalToBeAccounted(Object.values(res.notConfirmed).reduce((a, b) => {return a + (typeof b === "number" ? b : b.total);}, 0));   
      setTotalAccounted(Object.values(res.confirmed).reduce((a, b) => {return a + (typeof b === "number" ? b : b.total);}, 0));   
    });
    return (() => clearPrecogCounter());
  }, []);

  const calculateWidthPercentage = (value) => {
    return (value * 100) / totalToBeAccounted;
  };
  
  return  (
    <WidgetsPrecogCard isEmpty={false} className={"accountedFor"}>
      <div className="title" style={{display: "flex", justifyContent: "space-between"}}>
        <div><FormattedMessage id="preCog.widget.accountedFor"/></div>
        <div>{totalToBeAccounted}</div>
      </div>
      <div className="subtitleAccountedFor">
        <FormattedMessage id="preCog.widget.accountedForSubtitle"/>
        <span>{totalAccounted}</span>
      </div>
      {
        counterStatus?.ended ?
        /* Momentaneamente senza grafico a barre */
          <div className="counterDetail">
            {counterData?.notConfirmed?.countPassiveInvoice?.total > 0 && 
            <div>
              <span>
                <FormattedMessage id="preCog.widget.counterDetail.passiveInvoice"/>
              </span>
              <span> {counterData?.notConfirmed?.countPassiveInvoice?.total || 0}</span>
              <div style={{display: "flex", width: "100%"}}>
                {
                  counterData?.notConfirmed?.countPassiveInvoice?.total - counterData?.notConfirmed?.countPassiveInvoice?.withAssets > 0 &&
                  <BarChart 
                    value={counterData?.notConfirmed?.countPassiveInvoice?.total - counterData?.notConfirmed?.countPassiveInvoice?.withAssets} 
                    width={calculateWidthPercentage(counterData?.notConfirmed?.countPassiveInvoice?.total - counterData?.notConfirmed?.countPassiveInvoice?.withAssets)} 
                    background="#15939e"
                  />
                }
                {counterData?.notConfirmed?.countPassiveInvoice?.withAssets > 0 &&
                <Tooltip placement="topLeft" title={"Cespiti"} color={"rgb(0, 80, 117)"} getPopupContainer={trigger => trigger.parentNode} trigger="hover">
                  <div style={{width: "100%"}}>
                    <BarChart 
                      value={counterData?.notConfirmed?.countPassiveInvoice?.withAssets} 
                      width={calculateWidthPercentage(counterData?.notConfirmed?.countPassiveInvoice?.withAssets)} 
                      background="#79bfc6"
                    />
                  </div>
                </Tooltip>
                }
              </div>
            </div>}
            {counterData?.notConfirmed?.countActiveInvoice?.total > 0 && 
            <div>
              <span>
                <FormattedMessage id="preCog.widget.counterDetail.activeInvoice"/>
              </span>    
              
              <span> {counterData?.notConfirmed?.countActiveInvoice?.total || 0}</span>
                    
              {counterData?.notConfirmed?.countActiveInvoice?.total - counterData?.notConfirmed?.countActiveInvoice?.withAssets > 0 &&
              <div style={{display: "flex", width: "100%"}}>
                {counterData?.notConfirmed?.countActiveInvoice?.total - counterData?.notConfirmed?.countActiveInvoice?.withAssets &&
                <BarChart 
                  width={calculateWidthPercentage(counterData?.notConfirmed?.countActiveInvoice?.total - counterData?.notConfirmed?.countActiveInvoice?.withAssets)} 
                  value={counterData?.notConfirmed?.countActiveInvoice?.total - counterData?.notConfirmed?.countActiveInvoice?.withAssets} 
                  background="#5dc9c8"  
                />   
                }
                {counterData?.notConfirmed?.countActiveInvoice?.withAssets > 0 && 
                <Tooltip placement="topLeft" title={"Cespiti"} color={"rgb(0, 80, 117)"} getPopupContainer={trigger => trigger.parentNode} trigger="hover">
                  <div style={{width: "100%"}}>
                    <BarChart 
                      value={counterData?.notConfirmed?.countActiveInvoice?.withAssets} 
                      width={calculateWidthPercentage(counterData?.notConfirmed?.countActiveInvoice?.withAssets)} 
                      background="#9edfde"
                    />
                  </div>  
                </Tooltip>
                } 
              </div>
              }
            </div>}
            {counterData?.notConfirmed?.countReceipt > 0 && 
            <div>
              <span>
                <FormattedMessage id="preCog.widget.counterDetail.compensation"/>
              </span>
              <span> {counterData?.notConfirmed?.countReceipt || 0}</span>
              <div style={{display: "flex", width: "100%"}}>
                {counterData?.notConfirmed?.countReceipt > 0 &&
                  <BarChart 
                    value={counterData?.notConfirmed?.countReceipt} 
                    width={calculateWidthPercentage(counterData?.notConfirmed?.countReceipt)} 
                    background="#36688d" 
                  />
                }
              </div>
            </div>}
            {counterData?.notConfirmed?.countBankTransaction > 0 && 
            <div>
              <span>
                <FormattedMessage id="preCog.widget.counterDetail.bankMovements"/>
              </span>
              <span> {counterData?.notConfirmed?.countBankTransaction || 0}</span>
              <div style={{display: "flex", width: "100%"}}>
                {counterData?.notConfirmed?.countBankTransaction > 0 &&
                <BarChart 
                  value={counterData?.notConfirmed?.countBankTransaction} 
                  width={calculateWidthPercentage(counterData?.notConfirmed?.countBankTransaction)}
                  background="#35d4ec"  
                />
                }
              </div>
            </div>}
            {counterData?.notConfirmed?.countOthers > 0 && 
            <div>
              <span>
                <FormattedMessage id="preCog.widget.counterDetail.others"/>
              </span>
              <span> {counterData?.notConfirmed?.countOthers || 0}</span>
              <div style={{display: "flex", width: "100%"}}>
                {counterData?.notConfirmed?.countOthers > 0 &&
                <BarChart 
                  value={counterData?.notConfirmed?.countOthers}
                  width={calculateWidthPercentage(counterData?.notConfirmed?.countOthers)} 
                  background="#35d4ec"
                />
                }
              </div>
            </div>}
          </div>
          : 
          <div 
            style={{display: "flex", 
              alignItems: "center",
              width: "100%",
              justifyContent: "center"}}>
            <FontAwesomeIcon
              icon={["far", "circle-notch"]}
              spin
              style={{
                fontSize: "40px",
                color: "#1890ff"
              }}
            />
          </div>}
    </WidgetsPrecogCard>
  ) 
  ;
};

export default WidgetAccountedFor;